import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(landing)/testimonials/page.tsx");
